module.exports = __webpack_public_path__ + "img/second_logo.77d83764.svg";